import React from "react";
import QuestionCircleIcon from "@atlaskit/icon/core/question-circle";
import Button from "@atlaskit/button/new";
import Tooltip from "@atlaskit/tooltip";

const GetHelpExtensions = () => {
  const goToLink = () => {
    window.open("https://rixter.atlassian.net/wiki/spaces/RIFJ/pages/1315176449/iHub+for+Jira+Cloud", "_blank", "noreferrer");
  };
  return (
    <div className="ihub-actionmenu-icons">
      <Tooltip position="top" e content="Go to our online docs">
        <Button iconBefore={QuestionCircleIcon} appearance="subtle" onClick={goToLink} />
      </Tooltip>
    </div>
  );
};
export default GetHelpExtensions;
